import enums from "../enums";
import { sendSocketMessage } from "../middleware/middleware.js";

export const setChatPanelOpen = (isOpen) => ({
	type: enums.CHAT_SET_PANEL_OPEN,
	payload: isOpen,
});

export const setChatChannel = (channelId) => ({
	type: enums.CHAT_SET_CHANNEL,
	payload: channelId,
});

export const clearChatChannelMessages = (channelId) => ({
	type: enums.CHAT_CLEAR_CHANNEL_MESSAGES,
	payload: channelId,
});

export const setChatEligibility = ({ chatEnabled, loaded }) => ({
	type: enums.CHAT_SET_ELIGIBILITY,
	payload: { chatEnabled, loaded },
});

export const upsertChatMessage = (channelId, message) => ({
	type: enums.CHAT_UPSERT_MESSAGE,
	payload: { channelId, message },
});

export const removeChatMessage = (channelId, messageId) => ({
	type: enums.CHAT_REMOVE_MESSAGE,
	payload: { channelId, messageId },
});

export const subscribeChatChannel = (channelId) => (dispatch) => {
	if (!channelId) {
		return;
	}

	dispatch(
		sendSocketMessage({
			action: "subscribe",
			data: `chat:${channelId}`,
		})
	);
};

export const unsubscribeChatChannel = (channelId) => (dispatch) => {
	if (!channelId) {
		return;
	}

	dispatch(
		sendSocketMessage({
			action: "unsubscribe",
			data: `chat:${channelId}`,
		})
	);
};

export const switchChatChannel = (previousChannelId, nextChannelId) => (dispatch) => {
	if (previousChannelId && previousChannelId !== nextChannelId) {
		dispatch(unsubscribeChatChannel(previousChannelId));
		dispatch(clearChatChannelMessages(previousChannelId));
	}

	dispatch(setChatChannel(nextChannelId));

	if (nextChannelId) {
		dispatch(subscribeChatChannel(nextChannelId));
	}
};
